import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Beranda from "./pages/Beranda";
import Portfolio from "./pages/Portfolio/Portfolio";
import Blogs from "./pages/Blogs/HomeBlog";
import Blog from "./pages/Blogs/BlogTemplate";
import Contact from "./pages/Contact";

function App() {

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Beranda />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blogs/" element={<Blogs />} />
        <Route path="/blogs/:id" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </>
  );
}

export default App;
